var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title is-2 has-text-weight-light has-text-centered title-top"},[_vm._v(" "+_vm._s(_vm.post.title)+" ")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.post.body_html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }